// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"4d67af05","289":"c54536b0","362":"8c8c3456","453":"8701dc61","461":"cbdd14ca","783":"ebadb5d5","806":"14dc59a0","997":"3840f8d2"}[chunkId] + ".chunk.js";
};